import { Typography } from '@growdash/design-system/atoms';
import { Omit } from 'lodash';
import { Controller, useFormContext } from 'react-hook-form';
import { AutoComplete, AutoCompleteProps } from '../auto-complete';

// ----------------------------------------------------------------------

type Props = {
  name: string;
  rules?: any;
} & Omit<AutoCompleteProps, 'inputClassName'>;

// ----------------------------------------------------------------------

const RHFAutocomplete = ({
  name,
  placeholder,
  options,
  freeText = false,
  className = '',
  disabled = false,
  getOptionId,
  rules,
  ...other
}: Props) => {
  const { control, setValue } = useFormContext();
  return (
    <Controller
      key={name}
      name={name}
      disabled={disabled}
      control={control}
      rules={rules}
      render={({ field, fieldState: { error } }) => (
        <div>
          <AutoComplete
            // TODO: fix type
            // inputClassName={`${className} ${
            //   error?.message ? 'border-red-300 placeholder:text-red-500 ' : ''
            // }`}\
            className={className}
            getOptionId={getOptionId}
            disabled={disabled}
            freeText={freeText}
            options={options}
            placeholder={placeholder}
            onValueChange={newValue =>
              setValue(name, newValue, { shouldValidate: true })
            }
            {...field}
            {...other}
          />
          <Typography variant='body2' className='text-red-500'>
            {error?.message ?? ''}
          </Typography>
        </div>
      )}
    />
  );
};

export default RHFAutocomplete;
